"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;

var _victory = require("victory");

var _merge = _interopRequireDefault(require("lodash/merge"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const common = {
  axis: {
    style: {
      tickLabels: {
        fontSize: '10px',
        fontWeight: 400,
        fontFamily: 'Messina Sans'
      }
    }
  },
  bar: {
    style: {
      labels: {
        fontSize: '12px',
        fontWeight: 400,
        lineHeight: '16px',
        fontFamily: 'Messina Sans'
      }
    }
  }
};
const primary = (0, _merge.default)(_victory.VictoryTheme.grayscale, { ...common,
  strokeColor: 'ui3',
  gridStroveOdd: 'ui1',
  labelsFill: 'text.1',
  tickLabelsFill: 'text.2',
  chartColorPrimary: 'background.yellow',
  chartColorSecondary: 'background.aqua'
});
const theme = {
  primary
};
exports.theme = theme;
//# sourceMappingURL=BarChart.theme.js.map